export default function UiInput( {id, label, value, onChange} ){

    return <div className="form-group">
        <label htmlFor={id}>
            {label}
        </label>
        <input 
            className="form-control" 
            type="text" 
            id={id} 
            name={id} 
            value={value}
            onChange={onChange}
        />
    </div>

}